module.exports = __webpack_public_path__ + "img/浅色地图.78287049.png";